<template>
  <div>
    <base-title :title="StringLanguage.configurations" />
    <div class="configurations">
      <div class="item" @click="changeRoute('informacoes')">
        <div class="icon">
          <i class="fal fa-store"></i>
        </div>
        {{ StringLanguage.storeInformations }}
      </div>
      <div class="item" @click="changeRoute('cardapio')">
        <div class="icon">
          <i class="fal fa-book-open"></i>
        </div>
        {{ StringLanguage.catalog }}
        <base-badge
          v-if="!isValidCatalog()"
          type="exclamation"
          name="Incompleto"
        />
      </div>
      <div class="item" @click="changeRoute('localizacao')">
        <div class="icon">
          <i class="fal fa-map-marker-alt"></i>
        </div>
        {{ StringLanguage.localization }}
      </div>
      <div class="item" @click="changeRoute('horario', { done: timeStatus })">
        <div class="icon">
          <i class="fal fa-clock"></i>
        </div>
        {{ StringLanguage.workingTime }}
      </div>
      <div class="item" @click="changeRoute('regioes')">
        <div class="icon">
          <i class="fal fa-map-marked-alt"></i>
        </div>
        {{ StringLanguage.deliveryRegions }}
      </div>
      <div class="item" @click="changeRoute('pagamento')">
        <div class="icon">
          <i class="fal fa-credit-card-blank"></i>
        </div>
        {{ StringLanguage.payment }}
      </div>
      <div class="item" @click="changeRoute('imagens', { done: imageStatus })">
        <div class="icon">
          <i class="fal fa-image-polaroid"></i>
        </div>
        {{ StringLanguage.imagesStore }}
        <base-badge
          type="exclamation"
          name="Incompleto"
          v-if="!isValidImages()"
        />
      </div>
      <div class="item" @click="changeRoute('dominios')">
        <div class="icon">
          <i class="fal fa-rocket"></i>
        </div>
        {{ StringLanguage.domains }}
      </div>
      <div class="item" @click="changeRoute('impressoras')">
        <div class="icon">
          <i class="fal fa-print"></i>
        </div>
        {{ StringLanguage.printers }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseBadge from '@/components/Badge';
import {
  onBoardProgress,
  verifyToPublish,
  getDonePublish,
} from '@/plugins/core/schema/onBoardEnum';

export default {
  data() {
    return {
      currentProgress: 0,
      timeStatus: false,
      imageStatus: false,
    };
  },
  components: {
    BaseTitle,
    BaseBox,
    BaseBadge,
  },
  created() {
    this.verifyProgressLocal();
    this.changeSteps();
  },
  methods: {
    isValidImages() {
      const { configurations } = this;
      return (
        !!configurations.images &&
        !!configurations.images.logo &&
        !!configurations.images.background_mobile
      );
    },
    isValidCatalog() {
      const { configurations } = this;
      return !!configurations.catalogChanged;
    },
    verifyProgressLocal() {
      if (this.configurations.basic_info) {
        const progress = verifyToPublish(this.configurations);
        this.currentProgress = progress;
      }
    },
    changeRoute(routeName, params) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      this.$router.push({ name: routeName });
    },
    changeSteps() {
      const progress = this.currentProgress;

      // Horários de atendimento
      this.timeStatus = !!(progress & onBoardProgress.STEP_5_DONE);

      // Imagens
      this.imageStatus = !!(progress & onBoardProgress.STEP_6_DONE);
    },
  },
  computed: {
    ...mapState({
      configurations: (state) => state.store.configurations,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
  watch: {
    configurations() {
      this.verifyProgressLocal();
      this.changeSteps();
    },
  },
};
</script>

<style scoped>
.configurations {
  display: flex;
  flex-wrap: wrap;
}

.configurations .item {
  background-color: #414147;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
  flex: 0 32%;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}

@media (hover: hover) and (pointer: fine) and (min-width: 992px) {
  .configurations .item:hover {
    background-color: #3d3d42;
  }
}

.configurations .item .icon {
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.configurations .item:not(:nth-child(3n)) {
  margin-right: 20px;
}

.configurations .item {
  color: #999999;
  font-size: 14px;
}

.configurations .item .icon i {
  color: #999999;
  font-size: 17px;
}

@media (hover: hover) and (pointer: fine) and (min-width: 992px) {
  .configurations .item:hover,
  .configurations .item:hover i {
    color: var(--default);
  }
}

@media screen and (max-width: 1149px) {
  .configurations .item {
    flex: 1 47%;
  }
  .configurations .item:nth-child(1n) {
    margin-right: 20px;
  }
}

@media screen and (max-width: 991px) {
  .configurations .item {
    flex: 1 100%;
  }
  .configurations .item:nth-child(1n),
  .configurations .item:not(:nth-child(3n)) {
    margin-right: 0;
  }
}
</style>
